import { httpGet } from "../../../Commons/HttpServer/AttributeRouting/Methods";
import { httpReturn } from "../../../Commons/HttpServer/AttributeRouting/Results";
import { StreamReturnResult } from "../../../Commons/HttpServer/AttributeRouting/Results/StreamResultHandler";
import { SingletonController } from "../../../Commons/HttpServer/ExpressWrapper/SingletonController";
import { httpType, httpUrlParam } from "../../../Commons/HttpServer/AttributeRouting/Params";

import { CandyWidgetDevServer } from "./DevServers/CandyWidgetDevServer";

export interface BuildServerCandyWidgetControllerOptions {
    frontEndDevMode: boolean;
    devServerUrl: string;
}

const defaultOptions: BuildServerCandyWidgetControllerOptions = {
    frontEndDevMode: false,
    devServerUrl: "https://localhost:8081",
};

export class BuildServerCandyWidgetController extends SingletonController {
    private readonly engineDirectory: string;
    // @ts-ignore
    private readonly options: Partial<BuildServerCandyWidgetControllerOptions>;
    private devServer?: CandyWidgetDevServer;
    private readonly buildDebugOnly: boolean;

    public constructor(
        engineDirectory: string,
        buildDebugOnly: boolean,
        options: Partial<BuildServerCandyWidgetControllerOptions>
    ) {
        super();
        this.options = { ...defaultOptions, ...options };
        this.engineDirectory = engineDirectory;
        this.buildDebugOnly = buildDebugOnly;
    }

    @httpGet(
        /\/candy-widget\/(.*)/,
        httpReturn.StreamWithMime("application/javascript"),
        httpUrlParam("0", httpType.String)
    )
    public async getLoaderJs(fileName: string): Promise<StreamReturnResult> {
        return (await this.getOrCreateDevServer()).getFileStream(`candy-widget/${fileName}`);
    }

    private async getOrCreateDevServer(): Promise<CandyWidgetDevServer> {
        if (this.devServer == undefined) {
            this.devServer = new CandyWidgetDevServer(this.engineDirectory, this.buildDebugOnly);
            await this.devServer.start();
        }
        return this.devServer;
    }
}
